import { isNotEqual } from './common/compare';
import { directiveDescriptionChanged, directiveLocationAdded, directiveLocationRemoved, directiveArgumentAdded, directiveArgumentRemoved, directiveArgumentDescriptionChanged, directiveArgumentDefaultValueChanged, directiveArgumentTypeChanged, } from './changes/directive';
import { diffArrays, unionArrays } from '../utils/arrays';
export function changesInDirective(oldDirective, newDirective) {
    const changes = [];
    if (isNotEqual(oldDirective.description, newDirective.description)) {
        changes.push(directiveDescriptionChanged(oldDirective, newDirective));
    }
    // locations added
    changes.push(...diffArrays(newDirective.locations, oldDirective.locations).map((location) => directiveLocationAdded(newDirective, location)));
    // locations removed
    changes.push(...diffArrays(oldDirective.locations, newDirective.locations).map((location) => directiveLocationRemoved(oldDirective, location)));
    const oldNames = oldDirective.args.map((a) => a.name);
    const newNames = newDirective.args.map((a) => a.name);
    // arguments added
    changes.push(...diffArrays(newNames, oldNames).map((name) => directiveArgumentAdded(newDirective, newDirective.args.find((a) => a.name === name))));
    // arguments removed
    changes.push(...diffArrays(oldNames, newNames).map((name) => directiveArgumentRemoved(oldDirective, oldDirective.args.find((a) => a.name === name))));
    // common arguments
    unionArrays(oldNames, newNames).forEach((name) => {
        const oldArg = oldDirective.args.find((a) => a.name === name);
        const newArg = newDirective.args.find((a) => a.name === name);
        changes.push(...changesInDirectiveArgument(oldDirective, oldArg, newArg));
    });
    return changes;
}
function changesInDirectiveArgument(directive, oldArg, newArg) {
    const changes = [];
    if (isNotEqual(oldArg.description, newArg.description)) {
        changes.push(directiveArgumentDescriptionChanged(directive, oldArg, newArg));
    }
    if (isNotEqual(oldArg.defaultValue, newArg.defaultValue)) {
        changes.push(directiveArgumentDefaultValueChanged(directive, oldArg, newArg));
    }
    if (isNotEqual(oldArg.type.toString(), newArg.type.toString())) {
        changes.push(directiveArgumentTypeChanged(directive, oldArg, newArg));
    }
    return changes;
}
//# sourceMappingURL=directive.js.map